<div class="password-page">
  <div class="password-shell">
    <!-- Left Visual Panel -->
    <div class="password-visual">
      <div class="visual-content">
        <!-- <div class="visual-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div> -->

        <div class="visual-image">
          <img
            src="assets/images/absences_lms_login_banner.png"
            alt="Account security"
          />
        </div>

        <div class="visual-footer">
          <span>
            <i class="pi pi-lock"></i>
            Secure access
          </span>

          <span>
            <i class="pi pi-shield"></i>
            Protected account
          </span>
        </div>
      </div>
    </div>

    <!-- Right Panel -->
    <div class="password-panel">
      <div class="password-content">
        <!-- Mobile Logo -->
        <div class="mobile-brand">
          <img src="assets/images/ab_assist_new.svg" alt="Absence Assistance" />
        </div>

        <!-- Header -->
        <div class="password-header" *ngIf="!showMailConfirmation">
          <!-- <span class="password-eyebrow">
          Account setup
        </span> -->
        
          <h2>Create a new password</h2>

          <p>Choose a strong password to secure your account.</p>
       
        </div>

        <!-- Error -->
        @if (passwordChangeErr) {
        <div class="password-alert" role="alert">
          <div class="alert-icon">
            <i class="pi pi-exclamation-circle"></i>
          </div>
          <div class="alert-message">
            {{ passwordChangeErr }}
          </div>
          <button
            type="button"
            class="alert-close"
            (click)="removeErrMsg()"
            aria-label="Close notification"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>
        }

        <!-- Password Form -->
        @if (!showMailConfirmation) {
        <div class="password-form-wrapper">
          <form [formGroup]="passwordResetForm" class="password-form">
            <!-- New Password -->
            <div class="form-field">
              <label for="password"> New Password </label>
              <div class="input-wrapper">
                <i class="pi pi-lock input-icon"></i>
                <input
                  id="password"
                  class="form-input"
                  type="password"
                  placeholder="Enter new password"
                  autocomplete="new-password"
                  formControlName="password"
                />
              </div>
              <form-validation [control]="passwordResetForm.controls.password">
              </form-validation>
            </div>
            <!-- Confirm Password -->
            <div class="form-field">
              <label for="confirm_password"> Confirm Password </label>
              <div class="input-wrapper">
                <i class="pi pi-lock input-icon"></i>
                <input
                  id="confirm_password"
                  class="form-input"
                  type="password"
                  placeholder="Confirm your password"
                  autocomplete="new-password"
                  formControlName="confirm_password"
                />
              </div>
            </div>
            <!-- Password Match Error -->
            @if (errorMessage) {
            <p class="password-error">
              <i class="pi pi-info-circle"></i>
              {{ errorMessage }}
            </p>
            }
            <!-- Save -->
            <button
              type="button"
              class="password-button"
              (click)="confirmResetPassword(passwordResetForm.value)"
              [disabled]="!passwordResetForm.valid"
            >
              <span>Save Password</span>
              <i class="pi pi-arrow-right"></i>
            </button>
          </form>
        </div>
        }

        <!-- Success -->
        @if (showMailConfirmation) {
        <div class="success-wrapper">
          <div class="success-icon">
            <i class="pi pi-check"></i>
          </div>
          <h3>Password created successfully</h3>
          <p>
            Your password has been updated successfully. You can now sign in
            using your new password.
          </p>
          <button
            type="button"
            class="password-button"
            (click)="redirectToSignIn()"
          >
            <span>Return to Sign In</span>
            <i class="pi pi-arrow-right"></i>
          </button>
        </div>
        }

        <!-- Security -->
        <div class="password-security">
          <i class="pi pi-lock"></i>

          <span> Your password is securely encrypted. </span>
        </div>
      </div>
    </div>
  </div>
</div>
